import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const SearchIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="m22 21.29-5.16-5.16A8.432 8.432 0 0 0 19 10.49c0-4.69-3.81-8.5-8.5-8.5C5.81 1.99 2 5.81 2 10.5c0 4.69 3.81 8.5 8.5 8.5 2.16 0 4.13-.82 5.64-2.16L21.3 22l.71-.71H22ZM3 10.5C3 6.36 6.36 3 10.5 3c4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5C6.36 18 3 14.64 3 10.5Z" />
  </IconWrapper>
)

export default SearchIconMedium
